import {
  GET_REGIONAL_PURCHASING_MECHANISMS,
  GET_REGIONAL_PURCHASING_MECHANISMS_ERROR,
  GET_REGIONAL_PURCHASING_MECHANISMS_SUCCESS
} from './RegionalPurchasingMechanismsSection.actions'

const regionalPurchasingMechanismsSectionState = {
  categories: [],
  csv: [],
  data: [],
  error: null,
  loading: false
}

/**
 * The regional purchasing mechanisms section's reducer.
 */
const regionalPurchasingMechanismsSectionReducer = (
  state = regionalPurchasingMechanismsSectionState,
  { payload, type }
) => {
  switch (type) {
    case GET_REGIONAL_PURCHASING_MECHANISMS: {
      return { ...state, loading: true }
    }
    case GET_REGIONAL_PURCHASING_MECHANISMS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_REGIONAL_PURCHASING_MECHANISMS_SUCCESS: {
      return { ...state, categories: payload.categories, csv: payload.csv, data: payload.data, loading: false }
    }
    default: {
      return state
    }
  }
}

export default regionalPurchasingMechanismsSectionReducer
